import * as Yup from "yup";
import {FIELD_REQUIRED, FIELD_STRING,} from "../../../../common/constants/validationErrors";

import * as confimerPaiementSouscriptionFormNames from "./confimerPaiementSouscriptionFormNames";

export const confimerPaiementSouscriptionValidationSchema = Yup.object().shape({
  [confimerPaiementSouscriptionFormNames.CONFIRMER_PAIEMENT_MOYEN_PAIEMENT_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING).required(FIELD_REQUIRED),
  [confimerPaiementSouscriptionFormNames.FILE_FORM_NAME]:
    Yup.string()
    .required(FIELD_REQUIRED),
});
